var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('app-text',{attrs:{"color":_vm.titleColor || 'grey9',"size":"medium-bold"}},[_vm._v(_vm._s(_vm.title))]),_c('app-text',{attrs:{"color":"grey9","size":"small"}},[_vm._v(_vm._s(_vm.description))]),_c('v-divider',{staticClass:"mt-2 mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }